import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
const SelectCustom = ({ options, placeholder, onChange, value, label, loader, isDisabled, onFocus, isSearchable }) => {
    const { t } = useTranslation();
    const noOptionsMessage = () => {
        return t('nodata');
    };
    const loadingMessage = () => {
        return `${t('loading')}...`;
    };
    const customStyles = {
        menu: (provided) => (Object.assign(Object.assign({}, provided), { zIndex: 4 // Очень высокий z-index для меню
         }))
    };
    return (_jsxs(_Fragment, { children: [(label === null || label === void 0 ? void 0 : label.length) && _jsx("label", Object.assign({ style: { fontWeight: 'bold', color: '#454545' } }, { children: label })), _jsx("div", Object.assign({ style: { marginTop: '5px' } }, { children: _jsx(Select, { noOptionsMessage: noOptionsMessage, options: options, placeholder: placeholder, isLoading: loader, loadingMessage: loadingMessage, onChange: onChange, value: value, isDisabled: isDisabled, onFocus: onFocus, isSearchable: isSearchable || false, styles: Object.assign(Object.assign({}, customStyles), { menuPortal: base => (Object.assign(Object.assign({}, base), { zIndex: 9999 })) // чтобы не пряталось
                     }), menuPlacement: "auto", menuPortalTarget: document.body }) }))] }));
};
export default SelectCustom;
